"use client";

import useSWR from "swr";

import { API_URLS } from "./constants";
import { fetcher } from "./utils";

type AcknowledgementNeedParams = {
  unit: string,
  material: string,
};

type AcknowledgementNeedResponse = {
  need: boolean,
  documentVersion: string,
  object: string,
  text: string,
};

type AcknowledgementNeedResult = {
  need: boolean,
  documentVersion: string,
  objectId: string,
  text: string,
};

export const useAcknowledgementNeed = (params?: AcknowledgementNeedParams) => {
  const { unit, material } = params || {};

  return useSWR(unit && material ? [
    API_URLS.ACKNOWLEDGEMENT_NEED,
    unit,
    material,
  ] : null,
  async () => {
    const res = await fetcher<AcknowledgementNeedResponse>({
      url: API_URLS.ACKNOWLEDGEMENT_NEED,
      params: {
        "unit": unit!,
        "material": material!,
      },
    });

    return {
      need: res.need,
      documentVersion: res.documentVersion,
      objectId: res.object,
      text: res.text,
    } as AcknowledgementNeedResult;
  });
};
